import type { IconProps } from '../types/IconProps.ts';
export const FileVolume: IconProps = {
    name: 'FileVolume',
    children: [
        `<path d="M4 10V4c0-1.1.9-2 2-2h7.17a2 2 0 0 1 1.42.59L19.4 7.4a2 2 0 0 1 .6 1.43V20a2 2 0 0 1-2 2h-3" />`,
        `<path d="M13 2v5c0 1.1.9 2 2 2h5M3 19.07v-3.14a1 1 0 0 1 1-1h1.4a1 1 0 0 0 .66-.25l1.11-.96a.5.5 0 0 1 .83.38v6.94a.5.5 0 0 1-.79.41l-1.73-1.2a1 1 0 0 0-.57-.18H4a1 1 0 0 1-1-1M11.99 14.53c.76.79 1.82 2.98.02 5.5" />`,
    ]
};